<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onSave()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        {{ "control_image_settings" | translate }}
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_alt" | translate }}
                </label>
                <div class="col-xs-12">
                    <input
                        class="form-control"
                        [value]="imageField.alt().value()"
                        (input)="imageField.alt().value.set($any($event.target).value)"
                    />
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_link" | translate }}
                </label>
                <div class="col-xs-12" [class.has-warning]="linkInvalid() && linkTouched()">
                    <input
                        class="form-control"
                        placeholder="https://example.com"
                        [value]="imageField.link().value()"
                        (input)="setLink($any($event.target).value)"
                        (blur)="linkTouched.set(true)"
                    />
                    @if (linkInvalid() && linkTouched()) {
                        <small class="help-block mb-0">
                            {{ "control_errors_invalid_link" | translate }}
                        </small>
                    }
                </div>
                <div class="col-xs-12">
                    <label class="checkbox-inline">
                        <input
                            type="checkbox"
                            [checked]="imageField.isTargetBlank().value()"
                            (change)="imageField.isTargetBlank().value.set($any($event.target).checked)"
                        />
                        {{ "control_target" | translate }}
                    </label>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-9 control-label">
                    {{ "content_image_overlay" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch
                        [active]="imageField.isImageEffect().value()"
                        (toggleActiveEvent)="imageField.isImageEffect().value.set($event)"
                    />
                </div>
            </div>

            @if (imageField.isImageEffect().value()) {
                <div class="form-group mb-10">
                    <label class="col-xs-12">
                        {{ "condition_type" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <select class="form-control" (change)="setCondition($any($event.target).value)">
                            <option
                                [value]="EConditionType.ALWAYS"
                                [selected]="imageField.condition().value() === EConditionType.ALWAYS"
                            >
                                {{ "condition_type_always" | translate }}
                            </option>
                            <option
                                [value]="EConditionType.ON_HOVER"
                                [selected]="imageField.condition().value() === EConditionType.ON_HOVER"
                            >
                                {{ "condition_type_on_hover" | translate }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group mb-10">
                    <label class="col-xs-12">
                        {{ "overlay" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <select class="form-control" (change)="setOverlay($any($event.target).value || null)">
                            <option value="" disabled [selected]="!imageField.overlay().value()">
                                {{ "overlay_type_empty" | translate }}
                            </option>
                            <option
                                [value]="EOverlayType.TEXT"
                                [selected]="imageField.overlay().value() === EOverlayType.TEXT"
                            >
                                {{ "overlay_type_text" | translate }}
                            </option>
                            @if (imageField.condition().value() !== EConditionType.ON_HOVER) {
                                <option
                                    [value]="EOverlayType.MASK"
                                    [selected]="imageField.overlay().value() === EOverlayType.MASK"
                                >
                                    {{ "overlay_type_mask" | translate }}
                                </option>
                            }
                            @if (imageField.condition().value() !== EConditionType.ALWAYS) {
                                <option
                                    [value]="EOverlayType.IMAGE"
                                    [selected]="imageField.overlay().value() === EOverlayType.IMAGE"
                                >
                                    {{ "overlay_type_image" | translate }}
                                </option>
                            }
                            @if (imageField.condition().value() !== EConditionType.ALWAYS) {
                                <option
                                    [value]="EOverlayType.INCREASE"
                                    [selected]="imageField.overlay().value() === EOverlayType.INCREASE"
                                >
                                    {{ "overlay_type_increase" | translate }}
                                </option>
                            }
                            @if (imageField.condition().value() !== EConditionType.ALWAYS) {
                                <option
                                    [value]="EOverlayType.DECREASE"
                                    [selected]="imageField.overlay().value() === EOverlayType.DECREASE"
                                >
                                    {{ "overlay_type_decrease" | translate }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
                @if (imageField.overlay().value() === EOverlayType.TEXT) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_image_text" | translate }}
                            <span class="pull-right color-light char-count">
                                {{ imageField.description().value()?.length || 0 }}/{{
                                    CSS_RESTRICTIONS.MAX_DESCRIPTION_LENGTH
                                }}
                            </span>
                        </label>
                        <div class="col-xs-12">
                            <textarea
                                class="form-control"
                                [placeholder]="'default_description' | translate"
                                [maxLength]="CSS_RESTRICTIONS.MAX_DESCRIPTION_LENGTH"
                                [value]="imageField.description().value()"
                                (input)="imageField.description().value.set($any($event.target).value)"
                            >
                            </textarea>
                        </div>
                    </div>
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_text_style" | translate }}
                        </label>
                        <div class="col-xs-4">
                            <sp-input-num
                                suffixText="px"
                                [max]="FONT_SIZE_MAX"
                                [value]="imageField.fontSize().value()"
                                (valueChange)="imageField.fontSize().value.set($event)"
                            />
                        </div>
                        <div class="col-xs-6">
                            <div class="btn-group btn-group-justified" data-toggle="buttons">
                                <label
                                    class="btn btn-grey active"
                                    [class.active]="isActiveTextStyle(EFontStyle.AT)"
                                    (click)="toggleActiveTextStyle(EFontStyle.AT)"
                                >
                                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                                </label>
                                <label
                                    class="btn btn-grey"
                                    [class.active]="isActiveTextStyle(EFontStyle.B)"
                                    (click)="toggleActiveTextStyle(EFontStyle.B)"
                                >
                                    <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                                </label>
                                <label
                                    class="btn btn-grey"
                                    [class.active]="isActiveTextStyle(EFontStyle.I)"
                                    (click)="toggleActiveTextStyle(EFontStyle.I)"
                                >
                                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                                </label>
                            </div>
                        </div>
                        <div class="col-xs-2">
                            <web-color-picker
                                [hideGradient]="true"
                                [color]="imageField.textColor().value()"
                                (colorChangeEvent)="imageField.textColor().value.set($event.value)"
                            />
                        </div>
                    </div>
                    <div class="form-group mb-20">
                        <label class="col-xs-10 control-label">
                            {{ "control_background_color" | translate }}
                        </label>
                        <div class="col-xs-2">
                            <sp-color-picker
                                [colorsPreset]="selectedThemeColors()"
                                [color]="imageField.textBackground().value()"
                                (colorChangeEvent)="imageField.textBackground().value.set($event.value)"
                            />
                        </div>
                    </div>
                    <div class="form-group mb-10">
                        <label class="col-xs-6">
                            {{ "control_padding" | translate }}
                        </label>
                        <div class="col-xs-6 text-right">
                            <div class="preset-padding-buttons">
                                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(0)">0</button>
                                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(15)">
                                    15
                                </button>
                                <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(30)">
                                    30
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-xs-12 d-flex">
                            <div class="d-flex align-items-center mr-5" style="flex-grow: 1">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="CSS_RESTRICTIONS.SIZE_MIN"
                                    [max]="CSS_RESTRICTIONS.SIZE_MAX"
                                    [value]="imageField.paddingLeft().value()"
                                    (valueChange)="imageField.paddingLeft().value.set($event)"
                                />
                            </div>
                            <div style="flex-grow: 1">
                                <div class="mb-10">
                                    <sp-input-num
                                        suffixText="px"
                                        [min]="CSS_RESTRICTIONS.SIZE_MIN"
                                        [max]="CSS_RESTRICTIONS.SIZE_MAX"
                                        [value]="imageField.paddingTop().value()"
                                        (valueChange)="imageField.paddingTop().value.set($event)"
                                    />
                                </div>
                                <sp-input-num
                                    suffixText="px"
                                    [min]="CSS_RESTRICTIONS.SIZE_MIN"
                                    [max]="CSS_RESTRICTIONS.SIZE_MAX"
                                    [value]="imageField.paddingBottom().value()"
                                    (valueChange)="imageField.paddingBottom().value.set($event)"
                                />
                            </div>
                            <div class="d-flex align-items-center ml-5" style="flex-grow: 1">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="CSS_RESTRICTIONS.SIZE_MIN"
                                    [max]="CSS_RESTRICTIONS.SIZE_MAX"
                                    [value]="imageField.paddingRight().value()"
                                    (valueChange)="imageField.paddingRight().value.set($event)"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-xs-12">
                            {{ "control_text_alignment" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <sp-radio-group
                                [selected]="imageField.textJustify().value()"
                                [type]="ERadioGroupType.horizontalPosition"
                                (changeSelectedEvent)="imageField.textJustify().value.set($event)"
                            />
                        </div>
                        <div class="col-xs-6">
                            <sp-radio-group
                                [selected]="imageField.textPosition().value()"
                                [type]="ERadioGroupType.verticalPosition"
                                (changeSelectedEvent)="imageField.textPosition().value.set($event)"
                            />
                        </div>
                    </div>
                }
                @if (imageField.overlay().value() === EOverlayType.MASK) {
                    <div class="form-group mb-20">
                        <div class="col-xs-12">
                            <div class="mask-wrapper">
                                @for (mask of EMaskShapeType | keyvalue; track mask) {
                                    <div
                                        class="mask-block carousel"
                                        [class.active]="imageField.maskShape().value() === mask.value"
                                        (click)="imageField.maskShape().value.set(mask.value)"
                                    >
                                        <div class="mask-shape" [ngClass]="mask.value"></div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                @if (imageField.overlay().value() === EOverlayType.IMAGE) {
                    <div class="form-group mb-20">
                        <sp-file-manager
                            [fmSourceType]="FmSourceType.LANDING"
                            [disabled]="buttonDisabled()"
                            [file]="imageField.overlayImage().value()"
                            [displayOnly]="[DirectoryItemCategory.Image]"
                            (setFileEvent)="setImage($event)"
                            (replaceFileEvent)="replaceImage($event)"
                        >
                            <ng-template
                                #previewTemplate
                                let-file="file"
                                let-replaceFileFn="replaceFileFn"
                                let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                            >
                                <div class="mb-20">
                                    <sp-control-handle
                                        [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                                        [controlHandleMainText]="file.name"
                                        (removeActionEvent)="imageField.overlayImage().value.set(null)"
                                        (replaceActionEvent)="replaceFileFn()"
                                        [isDisableEditor]="false"
                                    />
                                </div>
                            </ng-template>
                        </sp-file-manager>
                    </div>
                }
            }
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
